import React from 'react';
import { motion } from 'framer-motion';
import { Download } from 'lucide-react';
export function DownloadAppSection() {
  return <section className="py-24 bg-gradient-to-br from-[#5B9BD5] to-[#4A8AC4]" data-id="element-22">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-23">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center text-white" data-id="element-24">
          <div className="inline-flex items-center gap-2 bg-white/20 px-4 py-2 rounded-full mb-6" data-id="element-25">
            <Download className="w-4 h-4" data-id="element-26" />
            <span className="text-sm font-medium" data-id="element-27">Disponible ahora</span>
          </div>

          <h2 className="text-4xl lg:text-5xl font-bold mb-6 leading-tight" data-id="element-28">
            Descarga la app Emprende Fullpass
          </h2>

          <p className="text-xl text-white/90 mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-29">
            Lleva tu tarjeta digital siempre contigo. Accede a todos tus
            beneficios desde tu smartphone.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-30">
            {/* Play Store Button */}
            <motion.a href="https://play.google.com/store/apps/details?id=com.ipse.promred.emprendefullpass" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="inline-flex items-center justify-center bg-black text-white px-6 py-3 rounded-lg font-semibold shadow-lg hover:bg-gray-900 transition-colors" data-id="element-31">
              <svg className="w-6 h-6 mr-3" viewBox="0 0 24 24" fill="currentColor" data-id="element-32">
                <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" data-id="element-33" />
              </svg>
              <div className="text-left" data-id="element-34">
                <div className="text-xs" data-id="element-35">Descárgala en</div>
                <div className="text-sm font-bold" data-id="element-36">Google Play</div>
              </div>
            </motion.a>

            {/* App Store Button */}
            <motion.a href="https://apps.apple.com/pe/app/emprende-full-pass/id6756686490" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="inline-flex items-center justify-center bg-black text-white px-6 py-3 rounded-lg font-semibold shadow-lg hover:bg-gray-900 transition-colors" data-id="element-37">
              <svg className="w-6 h-6 mr-3" viewBox="0 0 24 24" fill="currentColor" data-id="element-38">
                <path d="M18.71,19.5C17.88,20.74 17,21.95 15.66,21.97C14.32,22 13.89,21.18 12.37,21.18C10.84,21.18 10.37,21.95 9.1,22C7.79,22.05 6.8,20.68 5.96,19.47C4.25,17 2.94,12.45 4.7,9.39C5.57,7.87 7.13,6.91 8.82,6.88C10.1,6.86 11.32,7.75 12.11,7.75C12.89,7.75 14.37,6.68 15.92,6.84C16.57,6.87 18.39,7.1 19.56,8.82C19.47,8.88 17.39,10.1 17.41,12.63C17.44,15.65 20.06,16.66 20.09,16.67C20.06,16.74 19.67,18.11 18.71,19.5M13,3.5C13.73,2.67 14.94,2.04 15.94,2C16.07,3.17 15.6,4.35 14.9,5.19C14.21,6.04 13.07,6.7 11.95,6.61C11.8,5.46 12.36,4.26 13,3.5Z" data-id="element-39" />
              </svg>
              <div className="text-left" data-id="element-40">
                <div className="text-xs" data-id="element-41">Descárgala en</div>
                <div className="text-sm font-bold" data-id="element-42">App Store</div>
              </div>
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>;
}